// @module Eureka.MaxaCategoryIcons.MaxaCategoryIcons
define('Eureka.MaxaCategoryIcons.MaxaCategoryIcons.View'
,	[
	'eureka_maxacategoryicons_maxacategoryicons.tpl'
	
	,	'Eureka.MaxaCategoryIcons.MaxaCategoryIcons.SS2Model'
	
	,	'Backbone'
    ]
, function (
	eureka_maxacategoryicons_maxacategoryicons_tpl
	
	,	MaxaCategoryIconsSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Eureka.MaxaCategoryIcons.MaxaCategoryIcons.View @extends Backbone.View
	return Backbone.View.extend({

		template: eureka_maxacategoryicons_maxacategoryicons_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			this.model = new MaxaCategoryIconsSS2Model();
			var self = this;
         	this.model.fetch().done(function(result) {
				console.log("result", result)
				let columns = self.getNumberOfColumns(result.length)
				for (var i = 0; i < result.length; i++) {
					result[i].textColour = self.textColorBasedOnBackground(result[i].colour)
					result[i].columns = columns
					if(result[i].textColour === "#fff"){
						result[i].isWhiteText = true;
					}
				}
				self.tiles = result
				self.render();
      		});
		}
	,	getNumberOfColumns: function getNumberOfColumns(columns) {
			return (columns % 3 === 0) ? "4": "3"
		}

	,	textColorBasedOnBackground: function textColorBasedOnBackground(backgroundColor) {
			backgroundColor = backgroundColor.substring(1);
			const r = parseInt(backgroundColor.substring(0,2), 16); // 0 ~ 255
			const g = parseInt(backgroundColor.substring(2,4), 16);
			const b = parseInt(backgroundColor.substring(4,6), 16);

			const srgb = [r / 255, g / 255, b / 255];
			const x = srgb.map((i) => {
				if (i <= 0.04045) {
					return i / 12.92;
				} else {
					return Math.pow((i + 0.055) / 1.055, 2.4);
				}
			});

			const L = 0.2126 * x[0] + 0.7152 * x[1] + 0.0722 * x[2];
			return L > 0.179 ? "#000" : "#fff";
		}
	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Eureka.MaxaCategoryIcons.MaxaCategoryIcons.View.Context
	,	getContext: function getContext()
		{
			return {
				tiles: this.tiles
			};
		}
	});
});
